import api from "../../../api/axios";

const root = (companyId) =>
  `/companies/${companyId}/imports/properties`;

function appendImportFields(body, {
  file,
  sheet,
  mapping,
  valueMappings,
  responsibleMapping,
  sourceNamespace,
  mediaMapping,
}) {
  body.append("file", file);
  if (sheet) body.append("sheet", sheet);
  body.append("mapping", JSON.stringify(mapping || {}));
  body.append("value_mappings", JSON.stringify(valueMappings || {}));
  body.append(
    "responsible_user_mapping",
    JSON.stringify(responsibleMapping || {}),
  );
  body.append("source_namespace", sourceNamespace || "");
  body.append("media_mapping", JSON.stringify(mediaMapping || {}));
}

export function inspectPropertyImport(companyId, { file, sheet }) {
  const body = new FormData();
  body.append("file", file);
  if (sheet) body.append("sheet", sheet);
  return api
    .post(`${root(companyId)}/inspect/`, body)
    .then((res) => res.data);
}

export function previewPropertyImport(
  companyId,
  { file, sheet, mapping, valueMappings, responsibleMapping, sourceNamespace, mediaMapping },
) {
  const body = new FormData();
  appendImportFields(body, {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
    mediaMapping,
  });
  return api
    .post(`${root(companyId)}/preview/`, body)
    .then((res) => res.data);
}

export function commitPropertyImport(
  companyId,
  {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
    mediaMapping,
    idempotencyKey,
  },
) {
  const body = new FormData();
  appendImportFields(body, {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
    mediaMapping,
  });
  return api
    .post(`${root(companyId)}/commit/`, body, {
      headers: { "Idempotency-Key": idempotencyKey },
    })
    .then((res) => res.data);
}

export function fetchPropertyImportOperation(companyId, operationId) {
  return api
    .get(`${root(companyId)}/operations/${operationId}/`)
    .then((res) => res.data);
}

export function fetchPropertyImportOperationRows(companyId, operationId, params) {
  return api
    .get(`${root(companyId)}/operations/${operationId}/rows/`, { params })
    .then((res) => res.data);
}

export function fetchPropertyImportMedia(companyId, operationId, params) {
  return api
    .get(`${root(companyId)}/operations/${operationId}/media/`, { params })
    .then((res) => res.data);
}
